module.exports = __webpack_public_path__ + "static/Bach_Arisio-9af1b97d62ef7c23ff3a2766b687c6d5.mp3";